export const getters = {
    GET_ACTIVITY_LOGS:(state)=>state.activityLogs
  }
  